import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { BRAND, buildWaLink } from "@/lib/constants";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#11233B] text-[#FAF4ED] mt-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img
              src={BRAND.logoLight}
              alt="iExplore"
              className="h-20 w-20 object-contain"
            />
            <div className="flex flex-col leading-none">
              <span className="font-serif text-3xl">iExplore</span>
              <span className="text-[10px] tracking-[0.28em] uppercase text-[#E8B89B] mt-1.5">
                Explore Beyond Limits
              </span>
            </div>
          </div>
          <p className="mt-8 text-[#FAF4ED]/70 leading-relaxed max-w-md text-sm">
            A specialized Ladakh travel partner. Curated itineraries, honest
            pricing, and on-ground expertise — for travellers who want the
            mountains done right.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.22em] text-[#E8B89B] mb-6">
            Explore
          </h4>
          <ul className="space-y-3 text-sm">
            <li>
              <Link
                to="/packages"
                className="link-underline text-[#FAF4ED]/80 hover:text-[#FAF4ED]"
              >
                All Packages
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="link-underline text-[#FAF4ED]/80 hover:text-[#FAF4ED]"
              >
                About iExplore
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="link-underline text-[#FAF4ED]/80 hover:text-[#FAF4ED]"
              >
                Plan My Trip
              </Link>
            </li>
            <li>
              <a
                href={buildWaLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline text-[#FAF4ED]/80 hover:text-[#FAF4ED]"
              >
                WhatsApp Inquiry
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.22em] text-[#E8B89B] mb-6">
            Get in Touch
          </h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-[#E8B89B]" />
              <a
                href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
                data-testid="footer-phone"
                className="text-[#FAF4ED]/80 hover:text-[#FAF4ED]"
              >
                {BRAND.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 text-[#E8B89B]" />
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="footer-email"
                className="text-[#FAF4ED]/80 hover:text-[#FAF4ED] break-all"
              >
                {BRAND.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-[#E8B89B]" />
              <span className="text-[#FAF4ED]/80">Specialists in Ladakh, India</span>
            </li>
          </ul>

          <div className="flex items-center gap-4 mt-8">
            <a
              href="#"
              aria-label="Instagram"
              className="p-2.5 border border-[#FAF4ED]/15 hover:bg-[#FAF4ED]/10 transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className="p-2.5 border border-[#FAF4ED]/15 hover:bg-[#FAF4ED]/10 transition-colors"
            >
              <Facebook size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#FAF4ED]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 text-xs text-[#FAF4ED]/50 flex flex-col sm:flex-row justify-between gap-3">
          <span>© {new Date().getFullYear()} iExplore. All rights reserved.</span>
          <span className="tracking-[0.18em] uppercase">Made for the mountains.</span>
        </div>
      </div>
    </footer>
  );
}
